import React from 'react';
import ReactDOM from 'react-dom/client';
import Landing from './pages/Landing';
import ServiceReport from './pages/ServiceReport';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import './assets/css/index.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/service/:siteId" element={<ServiceReport />} />
                <Route path="*" index element={<Landing />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
